export type CopilotErrorKind = "plan-upgrade" | "ai-unavailable" | "other";

export function copilotErrorKind(error: unknown): CopilotErrorKind {
  if (typeof error !== "object" || error === null || !("code" in error)) return "other";
  if (error.code === "PLAN_UPGRADE_REQUIRED") return "plan-upgrade";
  if (error.code === "AI_UNAVAILABLE") return "ai-unavailable";
  return "other";
}
